import script from "./LanguageMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageMenu.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageMenu.vue?vue&type=style&index=0&id=4287d5ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4287d5ec"]])

export default __exports__